/*=========================================================================================
  File Name: moduleADMINMutations.js
  Description: ADMIN Module Mutations
  ----------------------------------------------------------------------------------------
==========================================================================================*/


export default {
  SET_ADMINS (state, admins) {
    state.admins = admins
  },
  SET_INFO_DB(state, payload){
    state.infoDB = payload
  },
  ADD_ADMIN(state, payload){
      state.admins.push(payload);
  },
  UPDATE_ADMIN(state, payload){
    const index = state.admins.findIndex(admin => admin.id == payload.id);
    state.admins.splice(index, 1)
    state.admins.splice(index, 0, payload)
  }
}